import React from 'react';
import BusinessBillingRecordSection from '../../../sections/AdminDashboard/Finance/BusinessBillingRecord';

const BusinessBillingRecord = () => {
  return <BusinessBillingRecordSection />;
};

export default BusinessBillingRecord;
